
import { defineComponent } from "vue";
import WeekSchedule from "./WeekSchedule.vue";

export default defineComponent({
  name: "GTRSystem",
  components: { WeekSchedule },
});
